export enum UserRole {
    wbAdmin = "wbAdmin",
    customerAdmin = "customerAdmin",
    customerManager = "customerManager",
    customerReceptionist = "customerReceptionist",
    customerViewer = "customerViewer",
    user = "",
}

export enum UserRoleDisplay {
    wbAdmin = "Wunderbricks Administrator",
    customerAdmin = "Administrator",
    customerManager = "Manager",
    customerReceptionist = "Receptionist",
    customerViewer = "Viewer (read only)",
    user = "User",
}
